import { Spinner } from 'flowbite-react';
import { FC, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface ILoaderProps {
  show?: boolean;
  className?: HTMLAttributes<HTMLDivElement>['className'];
  hideDelay?: number;
}

const DEFAULT_HIDE_DELAY = 500;

export const Loader: FC<ILoaderProps> = ({
  show = false,
  className,
  hideDelay = DEFAULT_HIDE_DELAY,
}) => {
  return (
    <div
      className={twMerge(
        'absolute inset-0 z-10 flex items-center justify-center bg-black/40 backdrop-blur-sm transition-[opacity,visibility] ease-out',
        show
          ? 'visible opacity-100'
          : 'pointer-events-none invisible opacity-0',
        className,
      )}
      style={{
        transitionDuration: `${hideDelay}ms`,
        transitionProperty: 'opacity, visibility',
        transitionBehavior: 'allow-discrete',
      }}
    >
      <Spinner color="info" />
    </div>
  );
};
